import type { PrintChecksResponse } from 'pages/VendorsTablePage/components/PrintChecks/types';

export const printChecksHighVolumeData: PrintChecksResponse = {
  vendors: [
    {
      vendorNo: '1',
      vendorName: 'Tommie Turpin',
      invoices: [
        {
          invoiceId: '1-0-1'
        },
        {
          invoiceId: '1-0-2'
        }
      ],
      totalNetAmount: '$231.51'
    },
    {
      vendorNo: '2',
      vendorName: 'Vladamir Philbrook',
      invoices: [
        {
          invoiceId: '2-1-1'
        },
        {
          invoiceId: '2-1-2'
        }
      ],
      totalNetAmount: '$55.55'
    },
    {
      vendorNo: '3',
      vendorName: 'Keir Battabee',

      invoices: [
        {
          invoiceId: '3-2-1'
        },
        {
          invoiceId: '3-2-2'
        }
      ],
      totalNetAmount: '$31.33'
    },
    {
      vendorNo: '4',
      vendorName: 'Raye Dyball',

      invoices: [
        {
          invoiceId: '4-3-1'
        },
        {
          invoiceId: '4-3-2'
        }
      ],
      totalNetAmount: '$26.14'
    },
    {
      vendorNo: '5',
      vendorName: 'Myron Oulet',
      invoices: [
        {
          invoiceId: '5-4-1'
        },
        {
          invoiceId: '5-4-2'
        }
      ],
      totalNetAmount: '$6.05'
    },
    {
      vendorNo: '6',
      vendorName: 'Zahara Hodjetts',
      invoices: [
        {
          invoiceId: '6-5-1'
        },
        {
          invoiceId: '6-5-2'
        }
      ],
      totalNetAmount: '$57.05'
    },
    {
      vendorNo: '7',
      vendorName: 'Tamarah Hanwell',
      invoices: [
        {
          invoiceId: '7-6-1'
        },
        {
          invoiceId: '7-6-2'
        }
      ],
      totalNetAmount: '$40.06'
    },
    {
      vendorNo: '8',
      vendorName: 'Britteny Mirfin',
      invoices: [
        {
          invoiceId: '8-7-1'
        },
        {
          invoiceId: '8-7-2'
        }
      ],
      totalNetAmount: '$56.93'
    },
    {
      vendorNo: '9',
      vendorName: 'Dalli Hay',
      invoices: [
        {
          invoiceId: '9-8-1'
        },
        {
          invoiceId: '9-8-2'
        }
      ],
      totalNetAmount: '$40.54'
    },
    {
      vendorNo: '10',
      vendorName: 'Jennifer Wigg',
      invoices: [
        {
          invoiceId: '10-9-1'
        },
        {
          invoiceId: '10-9-2'
        }
      ],
      totalNetAmount: '$9.11'
    },
    {
      vendorNo: '11',
      vendorName: 'Andrey Muddicliffe',
      invoices: [
        {
          invoiceId: '11-10-1'
        },
        {
          invoiceId: '11-10-2'
        }
      ],
      totalNetAmount: '$40.09'
    },
    {
      vendorNo: '12',
      vendorName: 'Collete De Benedictis',
      invoices: [
        {
          invoiceId: '12-11-1'
        },
        {
          invoiceId: '12-11-2'
        }
      ],
      totalNetAmount: '$75.71'
    },
    {
      vendorNo: '13',
      vendorName: 'Carny Malkinson',
      invoices: [
        {
          invoiceId: '13-12-1'
        },
        {
          invoiceId: '13-12-2'
        }
      ],
      totalNetAmount: '$3.13'
    },
    {
      vendorNo: '14',
      vendorName: 'Raye Dyball',

      invoices: [
        {
          invoiceId: '4-3-1'
        },
        {
          invoiceId: '4-3-2'
        }
      ],
      totalNetAmount: '$26.14'
    },
    {
      vendorNo: '15',
      vendorName: 'Myron Oulet',
      invoices: [
        {
          invoiceId: '5-4-1'
        },
        {
          invoiceId: '5-4-2'
        }
      ],
      totalNetAmount: '$6.05'
    },
    {
      vendorNo: '16',
      vendorName: 'Zahara Hodjetts',
      invoices: [
        {
          invoiceId: '6-5-1'
        },
        {
          invoiceId: '6-5-2'
        }
      ],
      totalNetAmount: '$57.05'
    },
    {
      vendorNo: '17',
      vendorName: 'Tamarah Hanwell',
      invoices: [
        {
          invoiceId: '7-6-1'
        },
        {
          invoiceId: '7-6-2'
        }
      ],
      totalNetAmount: '$40.06'
    },
    {
      vendorNo: '18',
      vendorName: 'Britteny Mirfin',
      invoices: [
        {
          invoiceId: '8-7-1'
        },
        {
          invoiceId: '8-7-2'
        }
      ],
      totalNetAmount: '$56.93'
    },
    {
      vendorNo: '19',
      vendorName: 'Dalli Hay',
      invoices: [
        {
          invoiceId: '9-8-1'
        },
        {
          invoiceId: '9-8-2'
        }
      ],
      totalNetAmount: '$40.54'
    },
    {
      vendorNo: '20',
      vendorName: 'Jennifer Wigg',
      invoices: [
        {
          invoiceId: '10-9-1'
        },
        {
          invoiceId: '10-9-2'
        }
      ],
      totalNetAmount: '$9.11'
    },
    {
      vendorNo: '21',
      vendorName: 'Andrey Muddicliffe',
      invoices: [
        {
          invoiceId: '11-10-1'
        },
        {
          invoiceId: '11-10-2'
        }
      ],
      totalNetAmount: '$40.09'
    },
    {
      vendorNo: '22',
      vendorName: 'Collete De Benedictis',
      invoices: [
        {
          invoiceId: '12-11-1'
        },
        {
          invoiceId: '12-11-2'
        }
      ],
      totalNetAmount: '$75.71'
    },
    {
      vendorNo: '23',
      vendorName: 'Carny Malkinson',
      invoices: [
        {
          invoiceId: '13-12-1'
        },
        {
          invoiceId: '13-12-2'
        }
      ],
      totalNetAmount: '$3.13'
    },
    {
      vendorNo: '24',
      vendorName: 'Raye Dyball',

      invoices: [
        {
          invoiceId: '4-3-1'
        },
        {
          invoiceId: '4-3-2'
        }
      ],
      totalNetAmount: '$26.14'
    },
    {
      vendorNo: '25',
      vendorName: 'Myron Oulet',
      invoices: [
        {
          invoiceId: '5-4-1'
        },
        {
          invoiceId: '5-4-2'
        }
      ],
      totalNetAmount: '$6.05'
    },
    {
      vendorNo: '26',
      vendorName: 'Zahara Hodjetts',
      invoices: [
        {
          invoiceId: '6-5-1'
        },
        {
          invoiceId: '6-5-2'
        }
      ],
      totalNetAmount: '$57.05'
    },
    {
      vendorNo: '27',
      vendorName: 'Tamarah Hanwell',
      invoices: [
        {
          invoiceId: '7-6-1'
        },
        {
          invoiceId: '7-6-2'
        }
      ],
      totalNetAmount: '$40.06'
    },
    {
      vendorNo: '28',
      vendorName: 'Britteny Mirfin',
      invoices: [
        {
          invoiceId: '8-7-1'
        },
        {
          invoiceId: '8-7-2'
        }
      ],
      totalNetAmount: '$56.93'
    },
    {
      vendorNo: '29',
      vendorName: 'Dalli Hay',
      invoices: [
        {
          invoiceId: '9-8-1'
        },
        {
          invoiceId: '9-8-2'
        }
      ],
      totalNetAmount: '$40.54'
    },
    {
      vendorNo: '30',
      vendorName: 'Jennifer Wigg',
      invoices: [
        {
          invoiceId: '10-9-1'
        },
        {
          invoiceId: '10-9-2'
        }
      ],
      totalNetAmount: '$9.11'
    },
    {
      vendorNo: '31',
      vendorName: 'Andrey Muddicliffe',
      invoices: [
        {
          invoiceId: '11-10-1'
        },
        {
          invoiceId: '11-10-2'
        }
      ],
      totalNetAmount: '$40.09'
    },
    {
      vendorNo: '32',
      vendorName: 'Collete De Benedictis',
      invoices: [
        {
          invoiceId: '12-11-1'
        },
        {
          invoiceId: '12-11-2'
        }
      ],
      totalNetAmount: '$75.71'
    },
    {
      vendorNo: '33',
      vendorName: 'Carny Malkinson',
      invoices: [
        {
          invoiceId: '13-12-1'
        },
        {
          invoiceId: '13-12-2'
        }
      ],
      totalNetAmount: '$3.13'
    },
    {
      vendorNo: '34',
      vendorName: 'Raye Dyball',

      invoices: [
        {
          invoiceId: '4-3-1'
        },
        {
          invoiceId: '4-3-2'
        }
      ],
      totalNetAmount: '$26.14'
    },
    {
      vendorNo: '35',
      vendorName: 'Myron Oulet',
      invoices: [
        {
          invoiceId: '5-4-1'
        },
        {
          invoiceId: '5-4-2'
        }
      ],
      totalNetAmount: '$6.05'
    },
    {
      vendorNo: '36',
      vendorName: 'Zahara Hodjetts',
      invoices: [
        {
          invoiceId: '6-5-1'
        },
        {
          invoiceId: '6-5-2'
        }
      ],
      totalNetAmount: '$57.05'
    },
    {
      vendorNo: '37',
      vendorName: 'Tamarah Hanwell',
      invoices: [
        {
          invoiceId: '7-6-1'
        },
        {
          invoiceId: '7-6-2'
        }
      ],
      totalNetAmount: '$40.06'
    },
    {
      vendorNo: '38',
      vendorName: 'Britteny Mirfin',
      invoices: [
        {
          invoiceId: '8-7-1'
        },
        {
          invoiceId: '8-7-2'
        }
      ],
      totalNetAmount: '$56.93'
    },
    {
      vendorNo: '39',
      vendorName: 'Dalli Hay',
      invoices: [
        {
          invoiceId: '9-8-1'
        },
        {
          invoiceId: '9-8-2'
        }
      ],
      totalNetAmount: '$40.54'
    },
    {
      vendorNo: '40',
      vendorName: 'Jennifer Wigg',
      invoices: [
        {
          invoiceId: '10-9-1'
        },
        {
          invoiceId: '10-9-2'
        }
      ],
      totalNetAmount: '$9.11'
    },
    {
      vendorNo: '41',
      vendorName: 'Andrey Muddicliffe',
      invoices: [
        {
          invoiceId: '11-10-1'
        },
        {
          invoiceId: '11-10-2'
        }
      ],
      totalNetAmount: '$40.09'
    },
    {
      vendorNo: '42',
      vendorName: 'Collete De Benedictis',
      invoices: [
        {
          invoiceId: '12-11-1'
        },
        {
          invoiceId: '12-11-2'
        }
      ],
      totalNetAmount: '$75.71'
    },
    {
      vendorNo: '43',
      vendorName: 'Carny Malkinson',
      invoices: [
        {
          invoiceId: '13-12-1'
        },
        {
          invoiceId: '13-12-2'
        }
      ],
      totalNetAmount: '$3.13'
    },
    {
      vendorNo: '44',
      vendorName: 'Raye Dyball',

      invoices: [
        {
          invoiceId: '4-3-1'
        },
        {
          invoiceId: '4-3-2'
        }
      ],
      totalNetAmount: '$26.14'
    },
    {
      vendorNo: '45',
      vendorName: 'Myron Oulet',
      invoices: [
        {
          invoiceId: '5-4-1'
        },
        {
          invoiceId: '5-4-2'
        }
      ],
      totalNetAmount: '$6.05'
    },
    {
      vendorNo: '46',
      vendorName: 'Zahara Hodjetts',
      invoices: [
        {
          invoiceId: '6-5-1'
        },
        {
          invoiceId: '6-5-2'
        }
      ],
      totalNetAmount: '$57.05'
    },
    {
      vendorNo: '47',
      vendorName: 'Tamarah Hanwell',
      invoices: [
        {
          invoiceId: '7-6-1'
        },
        {
          invoiceId: '7-6-2'
        }
      ],
      totalNetAmount: '$40.06'
    },
    {
      vendorNo: '48',
      vendorName: 'Britteny Mirfin',
      invoices: [
        {
          invoiceId: '8-7-1'
        },
        {
          invoiceId: '8-7-2'
        }
      ],
      totalNetAmount: '$56.93'
    },
    {
      vendorNo: '49',
      vendorName: 'Dalli Hay',
      invoices: [
        {
          invoiceId: '9-8-1'
        },
        {
          invoiceId: '9-8-2'
        }
      ],
      totalNetAmount: '$40.54'
    },
    {
      vendorNo: '50',
      vendorName: 'Jennifer Wigg',
      invoices: [
        {
          invoiceId: '10-9-1'
        },
        {
          invoiceId: '10-9-2'
        }
      ],
      totalNetAmount: '$9.11'
    },
    {
      vendorNo: '51',
      vendorName: 'Andrey Muddicliffe',
      invoices: [
        {
          invoiceId: '11-10-1'
        },
        {
          invoiceId: '11-10-2'
        }
      ],
      totalNetAmount: '$40.09'
    },
    {
      vendorNo: '52',
      vendorName: 'Collete De Benedictis',
      invoices: [
        {
          invoiceId: '12-11-1'
        },
        {
          invoiceId: '12-11-2'
        }
      ],
      totalNetAmount: '$75.71'
    },
    {
      vendorNo: '53',
      vendorName: 'Carny Malkinson',
      invoices: [
        {
          invoiceId: '13-12-1'
        },
        {
          invoiceId: '13-12-2'
        }
      ],
      totalNetAmount: '$3.13'
    },
    {
      vendorNo: '54',
      vendorName: 'Raye Dyball',

      invoices: [
        {
          invoiceId: '4-3-1'
        },
        {
          invoiceId: '4-3-2'
        }
      ],
      totalNetAmount: '$26.14'
    },
    {
      vendorNo: '55',
      vendorName: 'Myron Oulet',
      invoices: [
        {
          invoiceId: '5-4-1'
        },
        {
          invoiceId: '5-4-2'
        }
      ],
      totalNetAmount: '$6.05'
    },
    {
      vendorNo: '56',
      vendorName: 'Zahara Hodjetts',
      invoices: [
        {
          invoiceId: '6-5-1'
        },
        {
          invoiceId: '6-5-2'
        }
      ],
      totalNetAmount: '$57.05'
    },
    {
      vendorNo: '57',
      vendorName: 'Tamarah Hanwell',
      invoices: [
        {
          invoiceId: '7-6-1'
        },
        {
          invoiceId: '7-6-2'
        }
      ],
      totalNetAmount: '$40.06'
    },
    {
      vendorNo: '58',
      vendorName: 'Britteny Mirfin',
      invoices: [
        {
          invoiceId: '8-7-1'
        },
        {
          invoiceId: '8-7-2'
        }
      ],
      totalNetAmount: '$56.93'
    },
    {
      vendorNo: '59',
      vendorName: 'Dalli Hay',
      invoices: [
        {
          invoiceId: '9-8-1'
        },
        {
          invoiceId: '9-8-2'
        }
      ],
      totalNetAmount: '$40.54'
    },
    {
      vendorNo: '60',
      vendorName: 'Jennifer Wigg',
      invoices: [
        {
          invoiceId: '10-9-1'
        },
        {
          invoiceId: '10-9-2'
        }
      ],
      totalNetAmount: '$9.11'
    },
    {
      vendorNo: '61',
      vendorName: 'Andrey Muddicliffe',
      invoices: [
        {
          invoiceId: '11-10-1'
        },
        {
          invoiceId: '11-10-2'
        }
      ],
      totalNetAmount: '$40.09'
    },
    {
      vendorNo: '62',
      vendorName: 'Collete De Benedictis',
      invoices: [
        {
          invoiceId: '12-11-1'
        },
        {
          invoiceId: '12-11-2'
        }
      ],
      totalNetAmount: '$75.71'
    },
    {
      vendorNo: '63',
      vendorName: 'Carny Malkinson',
      invoices: [
        {
          invoiceId: '13-12-1'
        },
        {
          invoiceId: '13-12-2'
        }
      ],
      totalNetAmount: '$3.13'
    },
    {
      vendorNo: '64',
      vendorName: 'Raye Dyball',

      invoices: [
        {
          invoiceId: '4-3-1'
        },
        {
          invoiceId: '4-3-2'
        }
      ],
      totalNetAmount: '$26.14'
    },
    {
      vendorNo: '65',
      vendorName: 'Myron Oulet',
      invoices: [
        {
          invoiceId: '5-4-1'
        },
        {
          invoiceId: '5-4-2'
        }
      ],
      totalNetAmount: '$6.05'
    },
    {
      vendorNo: '66',
      vendorName: 'Zahara Hodjetts',
      invoices: [
        {
          invoiceId: '6-5-1'
        },
        {
          invoiceId: '6-5-2'
        }
      ],
      totalNetAmount: '$57.05'
    },
    {
      vendorNo: '67',
      vendorName: 'Tamarah Hanwell',
      invoices: [
        {
          invoiceId: '7-6-1'
        },
        {
          invoiceId: '7-6-2'
        }
      ],
      totalNetAmount: '$40.06'
    },
    {
      vendorNo: '68',
      vendorName: 'Britteny Mirfin',
      invoices: [
        {
          invoiceId: '8-7-1'
        },
        {
          invoiceId: '8-7-2'
        }
      ],
      totalNetAmount: '$56.93'
    },
    {
      vendorNo: '69',
      vendorName: 'Dalli Hay',
      invoices: [
        {
          invoiceId: '9-8-1'
        },
        {
          invoiceId: '9-8-2'
        }
      ],
      totalNetAmount: '$40.54'
    },
    {
      vendorNo: '70',
      vendorName: 'Jennifer Wigg',
      invoices: [
        {
          invoiceId: '10-9-1'
        },
        {
          invoiceId: '10-9-2'
        }
      ],
      totalNetAmount: '$9.11'
    },
    {
      vendorNo: '71',
      vendorName: 'Andrey Muddicliffe',
      invoices: [
        {
          invoiceId: '11-10-1'
        },
        {
          invoiceId: '11-10-2'
        }
      ],
      totalNetAmount: '$40.09'
    },
    {
      vendorNo: '72',
      vendorName: 'Collete De Benedictis',
      invoices: [
        {
          invoiceId: '12-11-1'
        },
        {
          invoiceId: '12-11-2'
        }
      ],
      totalNetAmount: '$75.71'
    },
    {
      vendorNo: '73',
      vendorName: 'Carny Malkinson',
      invoices: [
        {
          invoiceId: '13-12-1'
        },
        {
          invoiceId: '13-12-2'
        }
      ],
      totalNetAmount: '$3.13'
    },
    {
      vendorNo: '74',
      vendorName: 'Raye Dyball',

      invoices: [
        {
          invoiceId: '4-3-1'
        },
        {
          invoiceId: '4-3-2'
        }
      ],
      totalNetAmount: '$26.14'
    },
    {
      vendorNo: '75',
      vendorName: 'Myron Oulet',
      invoices: [
        {
          invoiceId: '5-4-1'
        },
        {
          invoiceId: '5-4-2'
        }
      ],
      totalNetAmount: '$6.05'
    },
    {
      vendorNo: '76',
      vendorName: 'Zahara Hodjetts',
      invoices: [
        {
          invoiceId: '6-5-1'
        },
        {
          invoiceId: '6-5-2'
        }
      ],
      totalNetAmount: '$57.05'
    },
    {
      vendorNo: '77',
      vendorName: 'Tamarah Hanwell',
      invoices: [
        {
          invoiceId: '7-6-1'
        },
        {
          invoiceId: '7-6-2'
        }
      ],
      totalNetAmount: '$40.06'
    },
    {
      vendorNo: '78',
      vendorName: 'Britteny Mirfin',
      invoices: [
        {
          invoiceId: '8-7-1'
        },
        {
          invoiceId: '8-7-2'
        }
      ],
      totalNetAmount: '$56.93'
    },
    {
      vendorNo: '79',
      vendorName: 'Dalli Hay',
      invoices: [
        {
          invoiceId: '9-8-1'
        },
        {
          invoiceId: '9-8-2'
        }
      ],
      totalNetAmount: '$40.54'
    },
    {
      vendorNo: '80',
      vendorName: 'Jennifer Wigg',
      invoices: [
        {
          invoiceId: '10-9-1'
        },
        {
          invoiceId: '10-9-2'
        }
      ],
      totalNetAmount: '$9.11'
    },
    {
      vendorNo: '81',
      vendorName: 'Andrey Muddicliffe',
      invoices: [
        {
          invoiceId: '11-10-1'
        },
        {
          invoiceId: '11-10-2'
        }
      ],
      totalNetAmount: '$40.09'
    },
    {
      vendorNo: '82',
      vendorName: 'Collete De Benedictis',
      invoices: [
        {
          invoiceId: '12-11-1'
        },
        {
          invoiceId: '12-11-2'
        }
      ],
      totalNetAmount: '$75.71'
    },
    {
      vendorNo: '83',
      vendorName: 'Carny Malkinson',
      invoices: [
        {
          invoiceId: '13-12-1'
        },
        {
          invoiceId: '13-12-2'
        }
      ],
      totalNetAmount: '$3.13'
    },
    {
      vendorNo: '84',
      vendorName: 'Raye Dyball',

      invoices: [
        {
          invoiceId: '4-3-1'
        },
        {
          invoiceId: '4-3-2'
        }
      ],
      totalNetAmount: '$26.14'
    },
    {
      vendorNo: '85',
      vendorName: 'Myron Oulet',
      invoices: [
        {
          invoiceId: '5-4-1'
        },
        {
          invoiceId: '5-4-2'
        }
      ],
      totalNetAmount: '$6.05'
    },
    {
      vendorNo: '86',
      vendorName: 'Zahara Hodjetts',
      invoices: [
        {
          invoiceId: '6-5-1'
        },
        {
          invoiceId: '6-5-2'
        }
      ],
      totalNetAmount: '$57.05'
    },
    {
      vendorNo: '87',
      vendorName: 'Tamarah Hanwell',
      invoices: [
        {
          invoiceId: '7-6-1'
        },
        {
          invoiceId: '7-6-2'
        }
      ],
      totalNetAmount: '$40.06'
    },
    {
      vendorNo: '88',
      vendorName: 'Britteny Mirfin',
      invoices: [
        {
          invoiceId: '8-7-1'
        },
        {
          invoiceId: '8-7-2'
        }
      ],
      totalNetAmount: '$56.93'
    },
    {
      vendorNo: '89',
      vendorName: 'Dalli Hay',
      invoices: [
        {
          invoiceId: '9-8-1'
        },
        {
          invoiceId: '9-8-2'
        }
      ],
      totalNetAmount: '$40.54'
    },
    {
      vendorNo: '90',
      vendorName: 'Jennifer Wigg',
      invoices: [
        {
          invoiceId: '10-9-1'
        },
        {
          invoiceId: '10-9-2'
        }
      ],
      totalNetAmount: '$9.11'
    },
    {
      vendorNo: '91',
      vendorName: 'Andrey Muddicliffe',
      invoices: [
        {
          invoiceId: '11-10-1'
        },
        {
          invoiceId: '11-10-2'
        }
      ],
      totalNetAmount: '$40.09'
    },
    {
      vendorNo: '92',
      vendorName: 'Collete De Benedictis',
      invoices: [
        {
          invoiceId: '12-11-1'
        },
        {
          invoiceId: '12-11-2'
        }
      ],
      totalNetAmount: '$75.71'
    },
    {
      vendorNo: '93',
      vendorName: 'Carny Malkinson',
      invoices: [
        {
          invoiceId: '13-12-1'
        },
        {
          invoiceId: '13-12-2'
        }
      ],
      totalNetAmount: '$3.13'
    },
    {
      vendorNo: '94',
      vendorName: 'Raye Dyball',

      invoices: [
        {
          invoiceId: '4-3-1'
        },
        {
          invoiceId: '4-3-2'
        }
      ],
      totalNetAmount: '$26.14'
    },
    {
      vendorNo: '95',
      vendorName: 'Myron Oulet',
      invoices: [
        {
          invoiceId: '5-4-1'
        },
        {
          invoiceId: '5-4-2'
        }
      ],
      totalNetAmount: '$6.05'
    },
    {
      vendorNo: '96',
      vendorName: 'Zahara Hodjetts',
      invoices: [
        {
          invoiceId: '6-5-1'
        },
        {
          invoiceId: '6-5-2'
        }
      ],
      totalNetAmount: '$57.05'
    },
    {
      vendorNo: '97',
      vendorName: 'Tamarah Hanwell',
      invoices: [
        {
          invoiceId: '7-6-1'
        },
        {
          invoiceId: '7-6-2'
        }
      ],
      totalNetAmount: '$40.06'
    },
    {
      vendorNo: '98',
      vendorName: 'Britteny Mirfin',
      invoices: [
        {
          invoiceId: '8-7-1'
        },
        {
          invoiceId: '8-7-2'
        }
      ],
      totalNetAmount: '$56.93'
    },
    {
      vendorNo: '99',
      vendorName: 'Dalli Hay',
      invoices: [
        {
          invoiceId: '9-8-1'
        },
        {
          invoiceId: '9-8-2'
        }
      ],
      totalNetAmount: '$40.54'
    },
    {
      vendorNo: '100',
      vendorName: 'Jennifer Wigg',
      invoices: [
        {
          invoiceId: '10-9-1'
        },
        {
          invoiceId: '10-9-2'
        }
      ],
      totalNetAmount: '$9.11'
    }
  ],
  totalOwed: '$3225.01',
  totalNoOfVendors: 100
};

export const printChecksSelectedData = [
  {
    invoices: [{ invoiceId: '1-0-2', lockStatus: undefined }],
    totalNetAmount: '$123.50',
    vendorNo: '2021',
    vendorName: 'Tommie Turpin'
  }
];
